(() => {
  async function removeItems(keys, sectionIds) {
    const body = { updates: Object.fromEntries(keys.map((k) => [k, 0])) };
    if (sectionIds) {
      body.sections = sectionIds;
      body.sections_url = window.location.pathname;
    }
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    return res.json();
  }

  function applyCartSections(cartItems, parsedState) {
    cartItems.getSectionsToRender().forEach((section) => {
      const container = document.getElementById(section.id);
      if (!container) return;
      const target = container.querySelector(section.selector) || container;
      if (parsedState.sections?.[section.section]) {
        target.innerHTML = cartItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      }
    });
    cartItems.classList.toggle('is-empty', parsedState.item_count === 0);
  }

  let activeCharmRemove = null;

  class FfCharmRemove extends HTMLElement {
    connectedCallback() {
      this.querySelector('button').addEventListener('click', () => {
        activeCharmRemove = this;
      });
    }
  }

  document.addEventListener('click', async (e) => {
    const confirmBtn = e.target.closest('cart-remove-popup-button');
    if (!confirmBtn || !activeCharmRemove) return;

    const el = activeCharmRemove;
    activeCharmRemove = null;

    e.stopPropagation();

    const overlay = confirmBtn.closest('.general--popup__overlay');
    if (overlay) {
      overlay.style.display = 'none';
      overlay.classList.remove('opened');
    }

    const cartItems = el.closest('cart-drawer-items') || el.closest('cart-items');
    const isCartPage = cartItems?.tagName === 'CART-ITEMS';
    const line = el.dataset.bagLine;
    const linkedBagLine = el.dataset.linkedBagLine;
    const linkedBagKey = el.dataset.linkedBagKey;
    if (cartItems) {
      cartItems.enableLoading(line);
      if (linkedBagLine) cartItems.enableLoading(linkedBagLine);
    }

    try {
      const sectionIds = isCartPage ? cartItems.getSectionsToRender().map((s) => s.section) : null;

      let parsedState;
      if (linkedBagKey) {
        const siblingCount = parseInt(el.dataset.siblingCharmCount, 10) || 1;
        if (siblingCount <= 1) {
          const rawProps = JSON.parse(el.dataset.linkedBagProps || '[]');
          const bagProps = Object.fromEntries(rawProps);
          bagProps['_bag_id'] = '';
          await removeItems([el.dataset.charmKey]);
          const body = { id: linkedBagKey, properties: bagProps };
          if (sectionIds) {
            body.sections = sectionIds;
            body.sections_url = window.location.pathname;
          }
          const res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
          });
          parsedState = await res.json();
        } else {
          parsedState = await removeItems([el.dataset.charmKey], sectionIds);
        }
      } else {
        parsedState = await removeItems([el.dataset.charmKey], sectionIds);
      }

      if (isCartPage) {
        applyCartSections(cartItems, parsedState);
      } else {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ff-charms-cart' });
      }
    } finally {
      if (cartItems) {
        cartItems.disableLoading(line);
        if (linkedBagLine) cartItems.disableLoading(linkedBagLine);
      }
    }
  }, true);

  document.addEventListener('click', (e) => {
    if (e.target.closest('.popup--close')) activeCharmRemove = null;
  });

  let activePair = null;

  class FfCartRemovePair extends HTMLElement {
    connectedCallback() {
      this.querySelector('button').addEventListener('click', () => {
        activePair = this;
      });
    }
  }

  document.addEventListener('click', async (e) => {
    const confirmBtn = e.target.closest('cart-remove-popup-button');
    if (!confirmBtn || !activePair) return;

    const el = activePair;
    activePair = null;

    e.stopPropagation();

    const overlay = confirmBtn.closest('.general--popup__overlay');
    if (overlay) {
      overlay.style.display = 'none';
      overlay.classList.remove('opened');
    }

    const cartItems = el.closest('cart-drawer-items') || el.closest('cart-items');
    const isCartPage = cartItems?.tagName === 'CART-ITEMS';
    const line = el.dataset.index;
    const linkedCharmLines = el.dataset.linkedCharmLines ? el.dataset.linkedCharmLines.split('|') : [];

    if (!isCartPage && typeof window.sendRemoveFromCartEvent === 'function') {
      const bagCartItemElement = document.querySelector(`#CartDrawer-Item-${line}`);
      if (bagCartItemElement) window.sendRemoveFromCartEvent(bagCartItemElement, 'remove_all');
    }

    if (cartItems) {
      cartItems.enableLoading(line);
      linkedCharmLines.forEach((l) => cartItems.enableLoading(l));
    }

    const cartDrawerEl = document.querySelector('cart-drawer');
    try {
      const sectionIds = isCartPage
        ? cartItems.getSectionsToRender().map((s) => s.section)
        : cartDrawerEl?.getSectionsToRender().map((s) => s.id) ?? null;
      const charmKeys = el.dataset.linkedCharmKeys ? el.dataset.linkedCharmKeys.split('|') : [];
      const parsedState = await removeItems([el.dataset.ffBagKey, ...charmKeys], sectionIds);
      if (isCartPage) {
        applyCartSections(cartItems, parsedState);
      } else if (cartDrawerEl) {
        cartDrawerEl.classList.toggle('is-empty', parsedState.item_count === 0);
        cartDrawerEl.renderContents(parsedState);
      } else {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ff-charms-cart' });
      }
    } finally {
      if (cartItems) {
        cartItems.disableLoading(line);
        linkedCharmLines.forEach((l) => cartItems.disableLoading(l));
      }
    }
  }, true);

  document.addEventListener('click', (e) => {
    if (e.target.closest('.popup--close')) activePair = null;
  });

  document.addEventListener('DOMContentLoaded', () => {
    customElements.define('ff-charm-remove', FfCharmRemove);
    customElements.define('ff-cart-remove-pair', FfCartRemovePair);
  });
})();
